<i18n src="./resources/locales.json"></i18n>
<template>
  <v-hover v-slot:default="{ hover }">
    <SmsListItem :show-actions="showActions && hover">
      <template v-slot:avatar>
        <v-menu
          :open-on-hover="!$vuetify.breakpoint.mobile"
          bottom offset-y
          :z-index="1000"
          :close-on-content-click="$vuetify.breakpoint.mobile">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <SmsAvatar :contact="contact" />
            </div>
          </template>
          <SmsContactCard :contact="contact" />
        </v-menu>
      </template>

      <template v-slot:title :title="contact.displayName">
        <div @contextmenu.prevent="displayActionsContextMenuForMobile($event)">
          <span :title="contact.displayName">{{ contact.displayName }}</span>
        </div>
      </template>

      <template v-slot:subtitle>
        <div @contextmenu.prevent="displayActionsContextMenuForMobile($event)">
          <v-icon size="16">{{ contact.displayIcon }}</v-icon>
          {{ contact.number }}
        </div>
      </template>

      <template v-if="showActions" v-slot:actions>
        <v-tooltip v-if="contact.isEnterpriseContact" right>
          <template v-slot:activator="{ on }">
            <v-icon class="dimmed" color="grey" small v-on="on">
              mdi-lock
            </v-icon>
          </template>
          <span>{{ $t('tooltips.restrictedContactActions') }}</span>
        </v-tooltip>
        <v-menu v-else-if="!$vuetify.breakpoint.mobile" offset-x>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" width="32" height="32" icon @click.stop="">
              <v-icon :color="getSideBarActionsColor(hover)">
                mdi-dots-horizontal
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="action in actions"
              :key="action.label"
              @click="action.action()"
            >
              {{ action.label }}
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </SmsListItem>
  </v-hover>
</template>

<script>
import { mapActions } from 'vuex';
import ThemeMixin from '@/mixins/ThemeMixin';
import ToastMixin from '@/mixins/ToastMixin';
import SmsListItem from '@/components/SmsListItem';
import SmsAvatar from '@/components/SmsAvatar/SmsAvatar';
import SmsContactCard from '@/components/SmsContactCard/SmsContactCard';

export default {
  name: 'SmsContactItem',

  components: { SmsListItem, SmsAvatar, SmsContactCard },

  mixins: [ ThemeMixin, ToastMixin ],

  props: {
    contact: {
      type: Object,
      default: null
    },
    group: {
      type: Object,
      default: null
    },
    showActions: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    actions() {
      let actions = [];
      if (this.group) {
        actions = [
          {
            label: this.$t('groups.removeParticipant'),
            action: this.removeContactFromCurrentGroup
          }
        ];
      } else {
        actions = [
          {
            label: this.$t('contacts.editContact'),
            action: this.onEditContact
          },
          {
            label: this.$t('contacts.deleteContact'),
            action: this.onDeleteContact
          },
          {
            label: this.contact.isFavoriteContact ?
              this.$t('contacts.deleteFavorite') :
              this.$t('contacts.addtoFavorites'),
            action: this.contact.isFavoriteContact ?
              this.onRemoveFavoriteContact : this.addContactToFavoritesList
          }
        ];
      }

      return actions;
    }
  },

  methods: {
    ...mapActions('contactsV2', ['deleteUserContact']),
    ...mapActions('groupsV2', ['removeContactFromGroup']),
    ...mapActions('preferences', ['addContactToFavorites', 'removeContactFromFavorites']),

    onEditContact() {
      this.$root.$emit('open-contact-dialog', this.contact);
    },

    onDeleteContact() {
      const successMessage = this.$t('notifications.deleteContact', { name: this.contact.displayName });
      this.deleteUserContact(this.contact.id)
        .finally(() => {
          this.showSuccess(successMessage);
        });
    },

    removeContactFromCurrentGroup() {
      const successMessage = this.$t('notifications.deleteContactFromGroup', { name: this.group.groupName });
      this.removeContactFromGroup({ groupId: this.group.id, contactId: this.contact.contactId })
        .finally(() => {
          this.showSuccess(successMessage);
        });
    },

    displayActionsContextMenuForMobile(event) {
      if (this.$vuetify.breakpoint.mobile && this.showActions && !this.contact.isEnterpriseContact) {
        this.$root.$emit('open-context-menu', {
          actions: this.actions,
          positionX: event.clientX,
          positionY: event.clientY
        });
      }
    },

    onRemoveFavoriteContact() {
      this.removeContactFromFavorites(this.contact);
    },

    addContactToFavoritesList() {
      this.addContactToFavorites(this.contact);
    }
  }
};
</script>
